import React, { useState, useRef, useEffect, useContext } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTableSearch from "../../controls/MuiTableSearch";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";

//Import AntD
import { Modal } from "antd";

//Import from salesSlice.js
import {
  getSalesDetailsInfoFromServer,
  getSalesMasterInfoFromServer,
  deleteSalesDetailFromServer,
  getSalesDetailsforPrintfromServer,
  getSalesMasterFromServerByPagination,
  getSalesMasterCountFromServer,
} from "./salesSlice";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import Pages
import SalesThermalPrint from "./SalesThermalPrint";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import from SalesContext
import { SalesContext } from "./SalesContext";

//Import React Router Dom
import { useNavigate } from "react-router-dom";

//Import ReactToPrint
import { useReactToPrint } from "react-to-print";

//Import CSS
import "./sales.css";

const SalesEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signinUser = useSelector(getSignInUser);
  const { confirm } = Modal;

  //useContext
  const { setSalesDetailInfoFromContext } = useContext(SalesContext);
  //End useContext

  //useState
  const [loginUser, setLoginUser] = useState(signinUser);
  const [salesMastersList, setSalesMastersList] = useState([]);
  const [originalSalesMastersList, setOriginalSalesMastersList] = useState([]);
  const [salesMasterCount, setSalesMasterCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [printSalesDetails, setPrintSalesDetails] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  const [showChild, setShowChild] = useState(false);
  const [printReady, setPrintReady] = useState(false);
  //End useState

  //useRef
  const printRef = useRef();
  //End useRef

  const fetchDatasByPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getSalesMasterFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
      }
      if (Array.isArray(unwrappedResult.data))
        setSalesMastersList(unwrappedResult.data);
    } catch (err) {
      console.log({ ErrorOccured: err });
      setNotify({
        isOpen: true,
        message: err.message,
        severity: "error",
      });
    }
  };

  //useEffect
  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => {
          setLoginUser(result.data);
        });
    }

    const fetchDatas = async () => {
      try {
        const salesMastersListResult = await dispatch(
          getSalesMasterInfoFromServer()
        );
        const unwrappedResult = unwrapResult(salesMastersListResult);
        if (unwrappedResult.data.length > 0) {
          setOriginalSalesMastersList(unwrappedResult.data);
        }

        const salesMasterCountResult = await dispatch(
          getSalesMasterCountFromServer()
        );
        const unwrappedSalesMasterCountResult = unwrapResult(
          salesMasterCountResult
        );
        unwrappedSalesMasterCountResult.data[0].SalesMasterCount === undefined
          ? setSalesMasterCount(0)
          : setSalesMasterCount(
              unwrappedSalesMasterCountResult.data[0].SalesMasterCount
            );
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };

    // dispatch(getSalesMasterInfoFromServer())
    //   .then(unwrapResult)
    //   .then((result) => {
    //     setSalesMastersList(result.data);
    //     setOriginalSalesMastersList(result.data);
    //   })
    //   .catch((error) => console.log({ ErrorOccured: error }));

    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);

  useEffect(() => {
    fetchDatasByPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (showChild && printReady) {
      handlePrintClick();
      setPrintReady(false); // Reset printReady after printing
    }
  }, [showChild, printReady]);
  //End useEffect

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 120 },
    { id: "Id", label: "Id", minWidth: 90 },
    {
      id: "SalesNo",
      label: "No",
      minWidth: 100,
    },
    { id: "SalesDate", label: "Date", minWidth: 100 },
    { id: "Customer", label: "Customer", minWidth: 170 },
    {
      id: "CurrentAmount",
      label: "Current Amount",
      align: "right",
      minWidth: 130,
    },
    {
      id: "LessAmount",
      label: "Less Amount",
      align: "right",
      minWidth: 120,
    },
    {
      id: "OpeningBalance",
      label: "Opening Balance",
      align: "right",
      minWidth: 130,
    },
    {
      id: "NetAmount",
      label: "Net Amount",
      align: "right",
      minWidth: 140,
    },
  ];

  const handleSalesEdit = async (e, record) => {
    e.preventDefault();
    await dispatch(getSalesDetailsInfoFromServer(record))
      .then(unwrapResult)
      .then((result) => {
        setSalesDetailInfoFromContext(result.data);
        navigate("/sales");
      })
      .catch((error) => console.log({ ErrorOccured: error }));
  };

  const handleSalesDelete = async (salesmaster) => {
    let [customercode, customername] = salesmaster.Customer.split("-");
    confirm({
      title: `Are you sure to delete this sales - ${salesmaster.SalesNo} ?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        let [customercode, customername] = salesmaster.Customer.split(" - ");
        // let customer = customerList.find(
        //   (customer) => customer.CUCode === customercode
        // );
        await dispatch(
          deleteSalesDetailFromServer({
            ...salesmaster,
            customercode,
            loginUser,
          })
        )
          .then(unwrapResult)
          .then((result) => {
            // console.log(result);
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
              // dispatch(getSalesMasterInfoFromServer())
              //   .then(unwrapResult)
              //   .then((result) => {
              //     setSalesMastersList(result.data);
              //   })
              //   .catch((error) => console.log({ ErrorOccured: error }));
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getSalesMasterCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setSalesMasterCount(result.data[0].SalesMasterCount);
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        // console.log(page);
        let currentPage = parseInt(page + 1);
        // console.log(currentPage);
        // console.log(rowsPerPage);
        // console.log(salesMasterCount);
        const newTotalRecords = salesMasterCount - 1;
        // console.log(newTotalRecords);
        const totalPages = Math.ceil(newTotalRecords / rowsPerPage); // rowcount
        // console.log(totalPages);
        if (currentPage > totalPages) {
          // console.log("ajmal");
          // console.log(page);
          // console.log(rowsPerPage);
          // console.log(Math.max(totalPages - 1, 0));
          setPage(Math.max(totalPages - 1, 0)); // Ensures the page is at least 0
          await fetchDatasByPagination(page, rowsPerPage);
        } else {
          // console.log("thahseen");
          await fetchDatasByPagination(page + 1, rowsPerPage);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handlePrintClick = useReactToPrint({
    content: () => printRef.current,
  });

  const handleSalesPrint = async (salesMaster) => {
    await dispatch(getSalesDetailsforPrintfromServer(salesMaster))
      .then(unwrapResult)
      .then((result) => {
        setPrintSalesDetails(result.data);
        setShowChild(true);
        setPrintReady(true); // Set printReady to true
      })
      .catch((err) => {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      });
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasByPagination(page + 1, rowsPerPage);
    } else {
      const filteredRows = originalSalesMastersList.filter((sales) => {
        return sales.Customer.toLowerCase().includes(searchedVal.toLowerCase());
      });
      setSalesMastersList(filteredRows);
    }
  };

  return (
    <>
      <Alert notify={notify} setNotify={setNotify} />
      <Box className="salesboxcontainer">
        <Paper className="paper" elevation={2} sx={{ p: 2 }}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: "5px" }}
          >
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <h6>Sales Edit</h6>
              {/* <Button
                variant="outlined"
                size="small"
                onClick={handleRefresh}
                sx={{
                  height: "33px",
                  alignItems: "center",
                  ml: "10px",
                  mt: "-11px",
                }}
              >
                Refresh
              </Button> */}
              <Button
                className="btnrefresh"
                variant="contained"
                size="small"
                onClick={handleRefresh}
                sx={{
                  ml: "10px",
                  mt: "-10px",
                }}
              >
                Refresh
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: "flex", alignItems: "center", mt: "-7px" }}
            >
              <MuiTableSearch
                placeholder="Search Sales"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Grid>
          </Grid>
          <Divider />
          <CardContent>
            {/* <TableContainer sx={{ maxHeight: 1000 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(salesMastersList) &&
                  salesMastersList.length > 0 ? (
                    salesMastersList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((salesMaster) => {
                        console.log(salesMaster);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={salesMaster.Id}
                          >
                            {columns.map((column) => {
                              const value = salesMaster[column.id];
                              if (column.id === "Action") {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    <EditIcon
                                      className="editicon"
                                      fontSize="medium"
                                      onClick={(e) =>
                                        handleSalesEdit(e, salesMaster)
                                      }
                                    />
                                    <DeleteIcon
                                      className="deleteicon"
                                      fontSize="medium"
                                      onClick={() =>
                                        handleSalesDelete(salesMaster)
                                      }
                                    />
                                    <PrintIcon
                                      className="printicon"
                                      fontSize="medium"
                                      onClick={(e) =>
                                        handleSalesPrint(salesMaster)
                                      }
                                    />
                                  </TableCell>
                                );
                              } else {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value}
                                  </TableCell>
                                );
                              }
                            })}
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        No Sales found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer> */}

            <TableContainer sx={{ maxHeight: 1000 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        hidden={column.id === "Id" ? true : false}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salesMastersList.length > 0 ? (
                    salesMastersList.map((salesMaster) => (
                      <TableRow key={salesMaster.Id}>
                        <TableCell>
                          <EditIcon
                            className="editicon"
                            fontSize="medium"
                            onClick={(e) => handleSalesEdit(e, salesMaster)}
                          />
                          {/* <DeleteIcon
                            className="deleteicon"
                            fontSize="medium"
                            onClick={() => handleSalesDelete(salesMaster)}
                          /> */}
                          <PrintIcon
                            className="printicon"
                            fontSize="medium"
                            onClick={(e) => handleSalesPrint(salesMaster)}
                          />
                        </TableCell>
                        <TableCell hidden={true}>{salesMaster.Id}</TableCell>
                        <TableCell>{salesMaster.SalesNo}</TableCell>
                        <TableCell>{salesMaster.SalesDate}</TableCell>
                        <TableCell>{salesMaster.Customer}</TableCell>
                        <TableCell align="right">
                          {salesMaster.CurrentAmount}
                        </TableCell>
                        <TableCell align="right">
                          {salesMaster.LessAmount}
                        </TableCell>
                        <TableCell align="right">
                          {salesMaster.OpeningBalance}
                        </TableCell>
                        <TableCell align="right">
                          {salesMaster.NetAmount}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        No Sales found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              className="MuiTablePagination-selectLabel"
              rowsPerPageOptions={[10, 25, 50, 75, 100]}
              component="div"
              count={salesMasterCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Paper>
      </Box>
      <div style={{ display: "none" }}>
        {showChild && (
          <SalesThermalPrint salesRecord={printSalesDetails} ref={printRef} />
        )}
      </div>
    </>
  );
};

export default SalesEdit;
